import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChildren, QueryList } from '@angular/core';
import { ApiService } from '@app/shared/services/api/api.service';
import { RepairOrder, RepairOrderReview, ShippingInputType, ShippingType } from '@app/shared/services/api/api.models';
import { zip, of, throwError, Subscription, Observable } from 'rxjs';
import { RcmDetailsComponent } from '../rcm-details.component';
import { RcmStepperService } from '@app/rcm/rcm-stepper/rcm-stepper.service';
import { RcmStatusStepperService } from '@app/rcm/rcm-stepper/rcm-status-stepper.service';
//Commented as part of bug #43045
//import { ActivityService } from '@app/shared/services/rcm/activity/activity.service';

@Component({
  selector: 'aar-rcm-shipping',
  templateUrl: './rcm-shipping.component.html',
  styleUrls: ['./rcm-shipping.component.scss']
})
export class RcmShippingComponent implements OnInit, OnChanges {

  @Input('showBoth') showBoth: boolean;
  @Input('isEmpty') isEmpty: boolean;
  @Input('repairOrder') repairOrder: RepairOrderReview;
  direction: number; // default to outbound
  noActivityMessage = 'No Activity Yet';
  shippings: any;
  loading: boolean = false;

  //TODO: crate a global spot for these.  I copy-pasted them from rcm-details-component.ts
  statuses = {
    NEW_RO: 0,
    UNIT_SHIPPED_OUTBOUND: 1,
    SUPPLIER_RECEIPT: 2,
    QUOTE_PROCESSING: 3,
    QUOTE_APPROVED: 4,
    IN_FINAL_REPAIR: 5,
    UNIT_SHIPPED_INBOUND: 6,
    'RECEIPT_&_CLOSE': 7,
    RO_CLOSED: 8,
  };

  constructor(
    private apiService: ApiService,
    private rcmStepperService: RcmStepperService,
    private statusStepperService: RcmStatusStepperService){
    //Commented as part of bug #43045
    //private activityService:ActivityService) {

    this.rcmStepperService.rcmStepChange$.subscribe(value => {
      switch (value) {

        case 'SHIPPING OUTBOUND':
          this.direction = 1;
          break;
        case 'SHIPPING INBOUND':
          this.direction = 2;
          break;
        default:
          break;
      }
    });
  }

  init() {

    if (!this.repairOrder) {
      return;
    }

    const apiCalls = zip(
      this.apiService.getOutboundShippingByRoAndRoL(this.repairOrder.repairOrderNumber, this.repairOrder.repairOrderLine.repairOrderLineId),
      this.apiService.getInboundShippingByRoAndRoL(this.repairOrder.repairOrderNumber, this.repairOrder.repairOrderLine.repairOrderLineId),
    );

    const that = this;
    apiCalls.subscribe(([outboundShipping, inboundShipping]) => {
      that.shippings = {};
      that.shippings.outbound = outboundShipping;
      that.shippings.inbound = inboundShipping;
      this.generateShippingStage();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.init();
  }

  ngOnInit() {
    this.init();
  }

  private generateShippingStage(): void {
    const maxObSquence = Math.max(...this.shippings.outbound.map(x => x.sequence));
    this.shippings.outbound.forEach(x => {
      x.shippingStage = `${x.sequence}/${maxObSquence}`;
    });

    const maxIbSequence = Math.max(...this.shippings.inbound.map(x => x.sequence));
    this.shippings.inbound.forEach(x => {
      x.shippingStage = `${x.sequence}/${maxIbSequence}`;
    });
  }
}